"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Shield, Video, Lock } from "lucide-react";
export default function DueDiligence() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = [{
    icon: Shield,
    title: "Legal Title",
    description: "Every property comes with verified land titles from the Lands Commission. Download the official search report to confirm ownership and legal standing.",
    action: {
      label: "Download Report",
      to: "https://glass-house-portal.vercel.app/data-room" // Updated Link
    }
  }, {
    icon: Video,
    title: "Site Vision",
    description: "Access live 4G site cameras 24/7. Log in to view real-time construction progress and verify development milestones from anywhere in the world.",
    action: {
      label: "View Live Camera",
      to: "https://glass-house-portal.vercel.app" // Updated Link
    }
  }, {
    icon: Lock,
    title: "Financial Safety",
    description: "Your funds are held in secure escrow accounts. Payments are released only when verified milestones are met, ensuring your investment is protected.",
    action: {
      label: "Learn More",
      to: "https://glass-house-portal.vercel.app/request-access" // Updated Link
    }
  }];
  return <section id="duediligence" ref={containerRef} className="py-24 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className={`text-4xl lg:text-5xl font-display text-foreground mb-6 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            Due Diligence
          </h2>
          <p className={`text-lg text-muted-foreground transition-all duration-[var(--duration-slow)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            Transparency, verification, and security at every step of your investment journey.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`border border-border hover-lift transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${(i + 2) * 100}ms`
          }}>
                <CardHeader>
                  <div className="mb-4">
                    <div className="inline-flex items-center justify-center size-14 rounded-lg bg-accent/10 text-accent-dark">
                      <Icon className="size-7" strokeWidth={1.5} />
                    </div>
                  </div>
                  <CardTitle className="text-2xl text-foreground">{service.title}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                  <CardDescription className="text-base leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                  <a href={service.action.to} target="_blank" rel="noopener noreferrer">
                    <Button variant="outline" className="w-full">
                      {service.action.label}
                    </Button>
                  </a>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}